// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@awc/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 auto;
    `,
    offsetCss: css`
        justify-content: space-between;
        position: relative;
        &&& {
            flex-wrap: nowrap;
        }
    `,
};

carouselStyles.prevArrowButton = {
    variant: "secondary",
    css: css`
        border: 0;
        padding: 0;
        position: absolute;
        height: 486px;
        border-radius: 0;
        left: 4px;
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
        ${IconWrapper} {
            color: ${color("primary")};
            &,
            svg {
                height: 20px;
                width: 20px;
            }
        }
    `,
};

carouselStyles.nextArrowButton = {
    variant: "secondary",
    css: css`
        border: 0;
        padding: 0;
        position: absolute;
        height: 486px;
        border-radius: 0;
        right: 4px;
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
        ${IconWrapper} {
            color: ${color("primary")};
            &,
            svg {
                height: 20px;
                width: 20px;
            }
        }
    `,
};

carouselStyles.attributesGridItem = {
    width: 12,
    css: css`
        ${({ loading }: any) => loading && "visibility: hidden;"}
        border: 1px solid ${color("common.ui27")};
    `,
};
carouselStyles.attributesGridContainer = {
    gap: 0,
};
carouselStyles.carouselContentEmptyCellGridItem = carouselStyles.attributeLabelsCellGridItem = {
    width: [4, 2, 2, 2, 2],
};

carouselStyles.carouselCellGridItem = {
    width: [8, 10, 10, 10, 10],
    css: css`
        &&& {
            margin-bottom: 8px;
        }
    `,
};

carouselStyles.attributeValuesCellGridItem = {
    width: [8, 10, 10, 10, 10],
};

carouselStyles.carouselGridItem = {
    width: 12,
    css: css`
        border: 1px solid ${color("common.ui27")};
        padding: 20px;
        &&& {
            flex-grow: 1;
        }
    `,
};

carouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        position: relative;
        padding: 0 4px;
        display: flex;
        flex-direction: column;
    `,
};

carouselStyles.attributeLabelGridItem = {
    width: 12,
    css: css`
        &:not(:last-child) {
            border-bottom: 1px solid ${color("common.ui27")};
        }
        padding: 12px 4px;
        &:nth-child(even) {
            background-color: ${color("common.ui24")};
        }
    `,
};

carouselStyles.attributeLabelText = {
    ellipsis: true,
    weight: fontConfig.weight.bold,
};

carouselStyles.attributeValueGridItem = {
    width: 12,
    css: css`
        &:not(:last-child) {
            border-bottom: 1px solid ${color("common.ui27")};
        }
        padding: 12px 4px;
        &:nth-child(even) {
            background-color: ${color("common.ui24")};
        }
    `,
};
